export const name = "Voting Edition"
export const menu = "Voting"
export const edition = "Voting Edition"
export const suggestedPlayer = "2+ players"
export const color = {
    primary: {
        main:  '#272c6c',
        contrastText: '#f6f6f6',
    },
    secondary: {
        main:  '#181818',
    }
}
export const levels = ['Voting']
export const isExpansion = false

export const backDesc = [
    "Voting Edition"
]

export const instruction = [
    "We all know that it's important to vote, but we wanted to dig a little deeper. These questions are meant to explore not only our knowledge of politics and the process of voting but also our limiting beliefs. Not just why we're ready to vote, but why we may be on the fence.",
    "And finally some tools, resources, and prompts to go beyond just voting, but to vote informed. To play, find a friend or loved one wanting to explore an important topic that is often messier than a check on the ballot.",
    "Ready?",
    "Disclaimer: It's important to have open conversations with others, even when we don't agree. However, make sure to explore these questions with people you feel safe with. Political conversations can get charged. Practice healthy boundaries and step away from any conversation that doesn't show mutual respect.",
]

export const level1 = [
    "How did your upbringing\n shape your views on politics?\n How has it evolved over time?",
    "Do you hold any limiting beliefs\n when it comes to voting? If so,\n what are they?",
    "If you could enact one\n policy today, what would\n it be and why?",
    "When was the first time\n you voted? What got you to\n the voting booth?",
    "Have you ever had the\n opportunity to vote and\n not taken it? If so, why?",
    "If you could ask each\n presidential candidate one\n question and get and honest\n answer, what would\n you ask?",
    "When was the last time\n you changed your mind about\n something politically? What\n prompted your shift in\n perspective?",
    "What's one thing you feel\n uninformed about politically that\n you'd like to gather more information\n on? What's one small step you can\n take towards gaining more\n knowledge on this topic?",
    "What boundaries feel\n important for you to set in the\n conversation surrounding\n politics?",
    "I do / don't vote\n because ________.",
    "What do most people\n assume about your political\n views / beliefs? How accurate\n are those assumptions?",
    "What do you wish the\n people from the other side of\n the political spectrum understood\n about your POV? What do you wish\n you understood about theirs?",
    "The world needs\n more ________, and\n less _________.",
    "How has social media\n influenced your political\n views, if at all?",
    "How do you want to use\n your social media platform\n (big or small) to enact change\n that feels authentic to you?",
    "What biases can you recognize\n that you have regarding your\n current political stance?",
    "Where do you get the majority\n of your voting information? How\n have you checked it's credibility?\n (See resources key to find various\n fact-checking websites)",
    "Is there a political view\n you have that you feel too\n afraid to admit publicly?",
    "What's one thing you\n know about the voting process\n today, that you didn't in the\n previous election?",
    "If the election doesn't go your\n way, how will you or your loved\n one's lives be affected? Are you\n informed about the potential\n impact your vote / lack\n thereof will have?",
    "How would you describe\n the imporance of voting\n to your younger self?",
    "Was there a moment recently\n that drastically shaped your\n political ideology? If so,\n what was it?",
    "Do you have open conversations\n with people who hold differing\n political views as you?\n Why or why not?",

    "Reminder Normalize saying\n I don't have enough\n information on this\n topic to form an\n opinion just yet.",
    "Reminder Listen to learn\n even when you\n don't agree."
]

